function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316 0h-120c-15.439 0-28 12.561-28 28v44c0 4.418 3.582 8 8 8h160c4.418 0 8-3.582 8-8v-44c0-15.439-12.561-28-28-28z",
    fill: "#595965",
    "data-original": "#595965",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 28v44c0 4.42-3.58 8-8 8h-40c4.42 0 8-3.58 8-8v-44c0-15.44-12.56-28-28-28h40c15.44 0 28 12.56 28 28z",
    fill: "#44454e",
    "data-original": "#44454e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 64h-228c-20.953 0-38 17.047-38 38v372c0 20.953 17.047 38 38 38h228c20.953 0 38-17.047 38-38v-372c0-20.953-17.047-38-38-38z",
    fill: "#595965",
    "data-original": "#595965",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 102v372c0 20.95-17.05 38-38 38h-40c20.95 0 38-17.05 38-38v-372c0-20.95-17.05-38-38-38h40c20.95 0 38 17.05 38 38z",
    fill: "#44454e",
    "data-original": "#44454e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360 104h-208c-4.418 0-8 3.582-8 8v352c0 4.418 3.582 8 8 8h208c4.418 0 8-3.582 8-8v-352c0-4.418-3.582-8-8-8z",
    fill: "#6c63ff",
    "data-original": "#79cb9c",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 112v352c0 4.42-3.58 8-8 8h-40c4.42 0 8-3.58 8-8v-352c0-4.42-3.58-8-8-8h40c4.42 0 8 3.58 8 8z",
    fill: "#4343d1",
    "data-original": "#63ac7d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.999 264h-32v-48c0-8.262-11.07-11.079-15.023-3.831l-48 88c-2.902 5.32.952 11.831 7.023 11.831h32v48c0 8.276 11.08 11.06 15.023 3.831l48-88c2.902-5.32-.952-11.831-7.023-11.831z",
    fill: "#f1cc76",
    "data-original": "#f1cc76",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ebb15d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m267.999 264h-24v-35.37l8.98-16.46c3.953-7.251 15.02-4.432 15.02 3.83z",
    fill: "#ebb15d",
    "data-original": "#ebb15d",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.019 275.83-48 88c-3.945 7.251-15.02 4.428-15.02-3.83v-12.63l39.02-71.54c2.912-5.311-.952-11.83-7.02-11.83h24c6.058 0 9.938 6.51 7.02 11.83z",
    fill: "#ebb15d",
    "data-original": "#ebb15d",
    style: {}
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.ff21c413.svg";
export { ForwardRef as ReactComponent };